"use strict";

var base = require("../product/base");
var focusHelper = require("../components/focus");
var outFocusMenu = require("../global/outFocusMenu");
var lazyLoading = require("../global/lazyLoading");
var productStringing = require("../components/cartStringingService");
var removeHTMLTags = require("./../util/htmlTagRemover");
var initCartSliderEvents = require("../components/cartSliderEvents");
var initCustomTooltip = require("../components/customTooltip");
var isCart = $(".js-isCart").data("iscart");

/**
 * Displays the current coupon error message when entering an existing coupon code
 */
function updateCouponMessage() {
    // Retrieve url from cart.isml
    const cartCouponMessage = $(".cart-refresh-existing-coupon-message").val();
    // Retrieve url from checkout.isml
    const checkoutCouponMessage = $(".checkout-refresh-existing-coupon-message").val();
    // Retrieve existing url depending of either being in cart or in checkout page
    const couponURL = cartCouponMessage ? cartCouponMessage : checkoutCouponMessage;
    $.ajax({
        url: couponURL,
        type: "get",
        success: function (data) {
            // Append the message from the error message that comes from Cart-AddCoupon in the coupons-and-promos section
            $(".coupons-and-promos").empty().append(data.totals.discountsHtml);
        }
    });
}

/**
 * appends params to a url
 * @param {string} url - Original url
 * @param {Object} params - Parameters to append
 * @returns {string} result url with appended parameters
 */
function appendToUrl(url, params) {
    var newUrl = url;
    if (newUrl) {
        newUrl += (newUrl.indexOf("?") !== -1 ? "&" : "?") + Object.keys(params).map(function (key) {
            return key + "=" + encodeURIComponent(params[key]);
        }).join("&");
    }

    return newUrl;
}

/**
 * Checks whether the basket is valid. if invalid displays error message and disables
 * checkout button
 * @param {Object} data - AJAX response from the server
 */
function validateBasket(data) {
    var $checkoutBtn = $(".checkout-btn");
    var $cartError = $(".cart-error");
    var $mixedBasketError = $(".js-mixed-basket-error");
    var $playTestDisclaimer = $(".playtest-basket-disclaimer");

    if (data.valid.error) {
        if (data.valid.message) {
            var errorHtml = "<div class=\"alert alert-danger alert-dismissible valid-cart-error " +
                "fade show\" role=\"alert\">" +
                "<button type=\"button\" class=\"close\" data-dismiss=\"alert\" aria-label=\"Close\">" +
                "<span aria-hidden=\"true\">&times;</span>" +
                "</button>" + data.valid.message + "</div>";

            $cartError.html(errorHtml);

            if (data.valid.mixedBasketError) {
                var mixedBasketError = `<div class="alert alert-dismissible play-test-basket play-test-basket--error mb-3">
                    <span class="label-mixed-basket">
                        ${data.valid.message}
                    </span>
                    <button class="service-cordage-cross" data-dismiss="alert">
                        <svg class="svg-inline icon-close-small" role="img" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24">
                            <path fill="none" stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="3" d="M4.5 4.5l15 15m-15 0l15-15"></path>
                        </svg>
                    </button>
                    </div>`;

                $mixedBasketError.html(mixedBasketError);
                $playTestDisclaimer.addClass("d-none");
            }
        } else {
            var $numberOfItems = $(".number-of-items");

            $cartError.empty();
            $(".cart").remove();
            $(".cart-empty-validation").show();
            $numberOfItems.hide();
            $(".m-cart__content").addClass("m-cart__content-empty");
            $numberOfItems.empty();
            $(".minicart-quantity").empty().append(data.numItems);
            $(".minicart-link").attr({
                "aria-label": data.resources.minicartCountOfItems,
                title: data.resources.minicartCountOfItems
            });
            $(".minicart .popover .popover__contents").empty();
            $(".minicart .popover").removeClass("show");
        }

        $checkoutBtn.addClass("disabled");
    } else {
        $checkoutBtn.removeClass("disabled");
        $cartError.empty();
        $mixedBasketError.empty();

        if (data.containsPlayTestService) {
            $playTestDisclaimer.removeClass("d-none");
        } else if (data.containsStringingService) {
            $(".service-cordage").removeClass("d-none");
        }
    }
}

/**
 * re-renders the order totals and the number of items in the cart
 * @param {Object} data - AJAX response from the server
 */
function updateCartTotals(data) {
    $(".number-of-items").empty().append(data.resources.numberOfItems);
    $(".shipping-cost").empty().append(data.totals.totalShippingCost);
    $(".tax-total").empty().append(data.totals.totalTax);
    if ($("#checkout-main").length > 0) {
        $(".grand-total-sum").empty().append(data.totals.grandTotal);
    } else {
        $(".grand-total").empty().append(data.totals.grandTotal);
    }
    $(".sub-total").empty().append(data.totals.subTotal);
    $(".minicart-quantity").empty().append(data.numItems);
    $(".minicart-link").attr({
        "aria-label": data.resources.minicartCountOfItems,
        title: data.resources.minicartCountOfItems
    });

    $(".shipping-cost-label").addClass("d-none");
    $(".shipping-cost-label-estimated").removeClass("d-none");

    if (data.imprintGrossTotal) {
        $(".imprint-price").empty().append(data.imprintGrossTotal);
    }

    var $orderDiscount = $(".order-discount");
    var $shippingDiscount = $(".shipping-discount");

    if (data.totals.orderLevelDiscountTotal.value > 0) {
        $orderDiscount.removeClass("hide-order-discount");
        $(".order-discount-total").empty()
            .append("- " + data.totals.orderLevelDiscountTotal.formatted);
    } else {
        $orderDiscount.addClass("hide-order-discount");
    }

    if (data.totals.shippingLevelDiscountTotal.value > 0) {
        $shippingDiscount.removeClass("hide-shipping-discount");
        $(".shipping-discount-total").empty().append("- " +
            data.totals.shippingLevelDiscountTotal.formatted);
    } else {
        $shippingDiscount.addClass("hide-shipping-discount");
    }

    data.items.forEach(function (item) {
        if (item.renderedPromotions !== null) {
            $(".item-" + item.UUID).empty().append(item.renderedPromotions);
        }

        if (item.isPlayTest && item.playtestBaseProductPrice) {
            $(".item-total-" + item.UUID).find(".pricing").empty().append(item.playtestBaseProductPrice);
        } else if(item.priceTotal && item.priceTotal.renderedPrice) {
            $(".item-total-" + item.UUID).empty().append(item.priceTotal.renderedPrice);
        }
    });
}

/**
 * re-renders the order totals and the number of items in the cart
 * @param {Object} message - Error message to display
 */
function createErrorNotification(message) {
    var errorHtml = "<div class=\"alert alert-danger alert-dismissible valid-cart-error " +
        "fade show\" role=\"alert\">" +
        "<button type=\"button\" class=\"close\" data-dismiss=\"alert\" aria-label=\"Close\">" +
        "<span aria-hidden=\"true\">&times;</span>" +
        "</button>" + message + "</div>";

    $(".cart-error").html(errorHtml);
}

/**
 * re-renders the approaching discount messages
 * @param {Object} approachingDiscounts - updated approaching discounts for the cart
 */
function updateApproachingDiscounts(approachingDiscounts) {
    $(".approaching-discounts").empty().append(approachingDiscounts);
}

/**
 * Updates the availability of a product line item
 * @param {Object} data - AJAX response from the server
 * @param {string} uuid - The uuid of the product line item to update
 */
function updateAvailability(data, uuid) {
    var lineItem;
    var messages = "";

    for (var i = 0; i < data.items.length; i++) {
        if (data.items[i].UUID === uuid) {
            lineItem = data.items[i];
            break;
        }
    }

    if (lineItem) {
        $(".availability-" + lineItem.UUID).empty();
    }

    if (lineItem && lineItem.availability) {
        if (lineItem.availability.checkoutMessages) {
            lineItem.availability.checkoutMessages.forEach(function (message) {
                messages += "<p class=\"line-item-attributes\">" + message + "</p>";
            });
        }

        if (lineItem.availability.inStockDate) {
            messages += "<p class=\"line-item-attributes line-item-instock-date\">"
                + lineItem.availability.inStockDate
                + "</p>";
        }
    }
    if (lineItem) {
        $(".availability-" + lineItem.UUID).html(messages);
    }
}

/**
 * Finds an element in the array that matches search parameter
 * @param {array} array - array of items to search
 * @param {function} match - function that takes an element and returns a boolean indicating if the match is made
 * @returns {Object|null} - returns an element of the array that matched the query.
 */
function findItem(array, match) {
    for (var i = 0, l = array.length; i < l; i++) {
        if (match.call(this, array[i])) {
            return array[i];
        }
    }
    return null;
}

/**
 * Updates details of a product line item
 * @param {Object} data - AJAX response from the server
 * @param {string} uuid - The uuid of the product line item to update
 */
function updateProductDetails(data, uuid) {
    var lineItem = findItem(data.cartModel.items, function (item) {
        return item.UUID === uuid;
    });

    if (lineItem.variationAttributes) {
        var attrSelector;
        var newAttribute;
        var attribute;
        for (var i = 0; i < lineItem.variationAttributes.length; i += 1) {
            attribute = lineItem.variationAttributes[i];
            let attributeName = attribute.displayName;

            attrSelector = "." + attribute.displayName.replace(/\s/g, "-") + "-" + uuid;

            if (lineItem.isBabolatCup) {
                attributeName = $(attrSelector).closest(".item-attributes").data("babolatcup-age-text");
                if (!$(attrSelector).hasClass("js-babolatcup-variation")) {
                    $(attrSelector).addClass("js-babolatcup-variation");
                }
            }

            newAttribute = attributeName + ": " + attribute.displayValue;
            $(attrSelector).text(newAttribute);
        }

        var imageSelector = ".card.product-info.uuid-" + uuid + " .item-image > img";

        $(imageSelector).attr("srcset", lineItem.images.small[0].url);
        $(imageSelector).attr("src", lineItem.images.small[0].url);
        $(imageSelector).attr("alt", lineItem.images.small[0].alt);
        $(imageSelector).attr("title", lineItem.images.small[0].title);
    }

    if (lineItem.options && lineItem.options.length) {
        var option = lineItem.options[0];
        var optSelector = ".lineItem-options-values[data-option-id=\"" + option.optionId + "\"]";
        $(optSelector).data("value-id", option.selectedValueId);
        $(optSelector + " .line-item-attributes").text(option.displayName);
    }

    var qtySelector = ".quantity[data-uuid=\"" + uuid + "\"]";
    var maxOrderQuantity = lineItem.quantityOptions.maxOrderQuantity;

    // Clear existing options
    $(qtySelector).empty();

    // Add new options based on maxOrderQuantity
    for (var index = 1; index <= maxOrderQuantity; index++) {
        $(qtySelector).append($("<option>", {
            value: index,
            text: index
        }));
    }

    $(qtySelector).val(lineItem.quantity);
    $(qtySelector).data("pid", data.newProductId);

    $(".remove-product[data-uuid=\"" + uuid + "\"]").data("pid", data.newProductId);

    var priceSelector = ".line-item-price-" + uuid + " .sales .value";
    $(priceSelector).text(lineItem.price.sales.formatted);
    $(priceSelector).attr("content", lineItem.price.sales.decimalPrice);

    if (lineItem.price.list) {
        var listPriceSelector = ".line-item-price-" + uuid + " .list .value";
        $(listPriceSelector).text(lineItem.price.list.formatted);
        $(listPriceSelector).attr("content", lineItem.price.list.decimalPrice);
    }

    if (lineItem.isBabolatCup) {
        let $participantName = $(`.line-item-participant-name-${uuid}`);
        let updatedText = $participantName.data("text").replace("$0", lineItem.participantName);

        $participantName.text(updatedText);
    }
}

/**
 * replace content of modal
 * @param {string} actionUrl - url to be used to remove product
 * @param {string} productID - pid
 * @param {string} productName - product name
 * @param {string} uuid - uuid
 * @param {string} stringName - string product name
 * @param {string} stringServiceName - string-service product name
 */
function confirmDelete(actionUrl, productID, productName, uuid, stringName, stringServiceName) {
    var $deleteConfirmBtn = $(".cart-delete-confirmation-btn");
    var $productToRemoveSpan = $(".product-to-remove");
    var $stringToRemoveSpan = $(".string-to-remove");
    var $stringServiceToRemoveSpan = $(".string-service-to-remove");
    var $deleteConfirmationTitle = $(".modal-remove-product > .modal-title");
    var singleProductTitle= $deleteConfirmationTitle.data("single-product");
    var multipleProductTitle = $deleteConfirmationTitle.data("multiple-products");
    var babolatCupTitle = $deleteConfirmationTitle.data("babolat-cup-title");
    var $deleteConfirmationMessage = $(".delete-confirmation-message");
    var singleProductMessage= $deleteConfirmationMessage.data("single-product");
    var multipleProductsMessage = $deleteConfirmationMessage.data("multiple-products");
    let $babolatCupVariation = $(`.uuid-${uuid}`).find(".js-babolatcup-variation");

    $deleteConfirmBtn.data("pid", productID);
    $deleteConfirmBtn.data("action", actionUrl);
    $deleteConfirmBtn.data("uuid", uuid);

    $productToRemoveSpan.empty().append(productName);
    $stringToRemoveSpan.empty();
    $stringServiceToRemoveSpan.empty();
    $deleteConfirmationTitle.empty().append(singleProductTitle);
    $deleteConfirmationMessage.empty().append(singleProductMessage);

    if (stringName && stringServiceName) {
        $productToRemoveSpan.addClass("mb-1");
        $stringToRemoveSpan.append(stringName);
        $stringServiceToRemoveSpan.append(stringServiceName);
        $deleteConfirmationTitle.empty().append(multipleProductTitle);
        $deleteConfirmationMessage.empty().append(multipleProductsMessage);
    }

    if ($babolatCupVariation.length) {
        $productToRemoveSpan.empty().append(`${productName} - ${$babolatCupVariation.html()}`);
        $deleteConfirmationTitle.html(babolatCupTitle);
    }
}

function initAddToCart() {
    $(document).on("click", "button.add-to-cart-from-cart", function (ev) {
        var $addButton = $(ev.currentTarget);
        var addToCartUrl = $addButton.parent().find(".add-to-cart-url").val();
        var $parentTile = $addButton.parents(".c-product-slider__item");
        let $cardContainerStringing = $(".card-container-stringing");

        var form = {
            pid: $parentTile.data("pid"),
            pidsObj: [],
            childProducts: [],
            quantity: $parentTile.find(".quantity-select").val()
        };

        $.spinner().start();

        if (addToCartUrl) {
            $.ajax({
                url: addToCartUrl,
                method: "POST",
                data: form,
                success: function (data) {
                    if (data.cart.items.length === 1) {
                        $(".m-cart__content")
                            .removeClass("m-cart__content-empty")
                            .empty();
                        window.location.reload();
                    }

                    if (data.error) {
                        if ($(".add-to-cart-messages").length === 0) {
                            $("body").append("<div class=\"add-to-cart-messages\"></div>");
                        }

                        $addButton.prop("disabled", true);
                        $(".add-to-cart-messages").append("<div class=\"alert alert-danger add-to-basket-alert c-form-state c-form-state--error\"" + " role=\"alert\">" + data.message + "</div>");

                        setTimeout(function () {
                            $(".add-to-basket-alert").remove();
                            $addButton.prop("disabled", false);
                        }, 3000);
                    }

                    $(".js-update-products-cards").html(data.cartProductsTemplate);

                    if ($cardContainerStringing.length) {
                        productStringing();
                    }

                    updateCartTotals(data.cart);
                    validateBasket(data.cart);
                    lazyLoading.refreshLazyLoadingFeature(".product-image");

                    $.spinner().stop();
                },
                error: function () {
                    $.spinner().stop();
                }
            });
        }
    });
}

/**
* Binds events to product push tile elements
* @returns {void}
*/
function productSamplePushTileEvents() {
    // color swatch
    $(document).on("click", ".c-product-push a.swatch-link", function (e) {
        e.preventDefault();

        var $this = $(this);
        var $productContainer = $this.closest(".set-item");

        if ($this.attr("disabled") || ($this.hasClass("selected") && $this.hasClass("color-attribute"))) {
            return;
        }

        productPushTileAttributeSelect($this.attr("href"), $productContainer);
    });

    // quantity select
    $(document).on("change", ".c-product-push .product-push-quantity", function (e) {
        e.preventDefault();

        var $this = $(this);
        var $selectedOption = $this.find("option[value=" + this.value + "]");
        var $productContainer = $this.closest(".set-item");

        productPushTileAttributeSelect($selectedOption.data("url"), $productContainer);
    });

    // size select
    $(document).on("change", ".c-product-push .product-push-size", function (e) {
        e.preventDefault();

        var $this = $(this);
        var $productContainer = $this.closest(".set-item");

        productPushTileAttributeSelect(this.value, $productContainer);
    });

    $(document).on("click", "button.product-push-add-to-cart", function () {
        var $addButton = $(this);
        var addToCartUrl = $addButton.parent().find(".add-to-cart-url").val();
        let $cardContainerStringing = $(".card-container-stringing");

        var form = {
            pid: $addButton.data("pid"),
            pidsObj: [],
            childProducts: [],
            quantity: $addButton.closest(".set-item").find(".product-push-quantity").val()
        };

        $.spinner().start();

        if (addToCartUrl) {
            $.ajax({
                url: addToCartUrl,
                method: "POST",
                data: form,
                success: function (data) {
                    if (data.cart.items.length === 1) {
                        $(".m-cart__content")
                            .removeClass("m-cart__content-empty")
                            .empty();
                        window.location.reload();
                    }

                    if (data.error) {
                        if ($(".add-to-cart-messages").length === 0) {
                            $("body").append("<div class=\"add-to-cart-messages\"></div>");
                        }

                        $addButton.prop("disabled", true);
                        $(".add-to-cart-messages").append("<div class=\"alert alert-danger add-to-basket-alert c-form-state c-form-state--error\"" + " role=\"alert\">" + data.message + "</div>");

                        setTimeout(function () {
                            $(".add-to-basket-alert").remove();
                            $addButton.prop("disabled", false);
                        }, 3000);
                    }

                    $(".js-update-products-cards").html(data.cartProductsTemplate);

                    if ($cardContainerStringing.length) {
                        productStringing();
                    }

                    updateCartTotals(data.cart);
                    validateBasket(data.cart);
                    lazyLoading.refreshLazyLoadingFeature(".product-image");

                    $.spinner().stop();
                },
                error: function () {
                    $.spinner().stop();
                }
            });
        }
    });
}

/**
* Handles response from product sample push
* @param {Object} response - response object from product sample push
* @param {Object} $productContainer - jQuery object of the product container
*/
function handleVariantResponseProductSamplePush(response, $productContainer) {
    var $attributes = $productContainer.find(".attributes");
    var colorAttribute = $attributes.data("colorattribute");
    var optionsHtml;

    if (response.product && $productContainer.hasClass("c-product-push")) {

        $productContainer.find(".product-push-add-to-cart").attr("data-pid", response.product.id).data("pid", response.product.id);
        // update text attributes of product push tile
        if (response.product.attributesHtml) {
            $productContainer.find(".c-product-push__product__attributes").empty().append(response.product.attributesHtml);
        }

        var product = response.product;

        if (product && product.available && product.readyToOrder) {
            $productContainer.find(".product-push-add-to-cart").attr("disabled", false);
        } else {
            $productContainer.find(".product-push-add-to-cart").attr("disabled", true);
        }

        // update images
        if (response.product.images && response.product.images.small && response.product.images.small.length) {
            $productContainer.find(".product-image").attr("srcset", response.product.images.small[0].url);
        }

        // update color swatch
        if (response.product.variationAttributes && response.product.variationAttributes.length) {
            response.product.variationAttributes.forEach(function (attribute) {

                if (attribute.id === colorAttribute) {
                    var selectedValue = attribute.values.filter(function (value) {
                        return value.selected;
                    })[0];

                    if (selectedValue) {
                        $productContainer.find(".swatch-circle").removeClass("selected");
                        $productContainer.find(".swatch-circle[data-attr-value='" + selectedValue.id + "']").addClass("selected");
                    }

                    attribute.values.forEach(function (value) {
                        $productContainer.find(".swatch-circle[data-attr-value='" + value.id + "']")
                            .closest(".swatch-link")
                            .attr("href", value.url);
                    });

                } else {
                    optionsHtml = attribute.values
                        .map(function (sizeAttribute) {
                            return `<option class="m-product-detail__select-option ${sizeAttribute.selectable ? "selectable" : ""}"
                                value="${sizeAttribute.url}"
                                data-attr-value="${sizeAttribute.id}"
                                ${sizeAttribute.selected ? "selected" : ""}>
                                    ${sizeAttribute.displayValue}
                                </option>`;
                        })
                        .join("");

                    $productContainer.find(".product-push-size").empty().append(optionsHtml);
                }
            });
        }

        // update price
        if (response.product.price && response.product.price.html) {
            $productContainer.find(".product-push-prices").empty().html(response.product.price.html);
        }

        // update quantity
        if (response.product.quantities && response.product.quantities.length) {
            var quantities = response.product.quantities;
            optionsHtml = quantities
                .map(function (quantity) {
                    var selected = quantity.selected ? " selected " : "";

                    return "<option value=\"" + quantity.value + "\"  data-url=\"" + quantity.url + "\"" + selected + " >" + quantity.value + "</option>";
                })
                .join("");
            $productContainer.find(".product-push-quantity").empty().html(optionsHtml);
        }

        // update text attributes
        if (response.product && response.product.attributesHtml) {
            $productContainer.find(".c-product-push__product__attribute").empty().append(response.product.attributesHtml);
        }
    }
}

/**
* Handles the AJAX response for product sample push
* @param {string} selectedValueUrlDefault - the URL to send the AJAX request
* @param {Object} $productContainer - the jQuery object of the product container
*/
function productPushTileAttributeSelect(selectedValueUrlDefault, $productContainer) {
    var selectedValueUrl = selectedValueUrlDefault;

    if (selectedValueUrl) {
        selectedValueUrl += "&isExpliciteRecommendation=true";

        $.spinner().start();
        $.ajax({
            url: selectedValueUrl,
            method: "GET",
            success: function (data) {
                handleVariantResponseProductSamplePush(data, $productContainer);
                $.spinner().stop();
            },
            error: function () {
                $.spinner().stop();
            }
        });
    }
}


/**
* Refreshes the Einstein Recommendations sliders
*/
function refreshEinsteinRecommendations () {
    const $recommenderSliders = $(".m-recommendations-slider").children();

    if ($recommenderSliders.length === 0) {
        return;
    }

    window.location.reload();
}

module.exports = function () {
    var $body = $("body");
    let $cardContainerStringing = $(".card-container-stringing");

    initCartSliderEvents();
    initCustomTooltip();

    if ($cardContainerStringing.length) {
        productStringing();
    }

    initAddToCart();

    $body.on("click", ".remove-product", function (e) {
        e.preventDefault();

        var $this = $(this);
        var actionUrl = $this.data("action");
        var productID = $this.data("pid");
        var productName = $this.data("name");
        var stringName = $this.data("string-name");
        var stringServiceName = $this.data("string-service-name");
        var uuid = $this.data("uuid");

        if (stringName && stringServiceName) {
            confirmDelete(actionUrl, productID, productName, uuid, stringName, stringServiceName);
        } else {
            confirmDelete(actionUrl, productID, productName, uuid);
        }
    });

    $body.on("afterRemoveFromCart", function (e, data) {
        e.preventDefault();

        confirmDelete(data.actionUrl, data.productID, data.productName, data.uuid);
    });

    $(".optional-promo").click(function (e) {
        e.preventDefault();
        $(".promo-code-form").toggle();
    });

    $body.on("click", ".cart-delete-confirmation-btn", function (e) {
        e.preventDefault();
        var $cardContainerStringing = $(".card-container-stringing");
        var $this = $(this);
        var productID = $this.data("pid");
        var url = $this.data("action");
        var uuid = $this.data("uuid");
        var urlParams = {
            pid: productID,
            uuid: uuid
        };

        url = appendToUrl(url, urlParams);

        $("body > .modal-backdrop").remove();

        $.spinner().start();
        $.ajax({
            url: url,
            type: "get",
            dataType: "json",
            success: function (data) {
                let $minicartPopover = $(".minicart-popover");

                if (data.basket.items.length === 0) {
                    if ($minicartPopover.length && $minicartPopover.hasClass("show")) {
                        $minicartPopover.find(".js-minicart-close").trigger("click");
                    }

                    $(".cart").remove();
                    $(".cart-empty-validation").show();
                    $(".m-cart__content").addClass("m-cart__content-empty");
                    $(".number-of-items").empty();
                    $(".minicart-quantity").empty().append(data.basket.numItems).toggleClass("d-none", data.basket.numItems === 0);
                    $(".js-minicart-popover").toggleClass("c-button--icon-opacity", data.basket.numItems > 0);
                    $(".minicart-link").attr({
                        "aria-label": data.basket.resources.minicartCountOfItems,
                        title: data.basket.resources.minicartCountOfItems
                    });

                    $(".minicart .popover .popover__contents").empty();
                    $body.removeClass("modal-open");
                    $("html").removeClass("veiled");
                    validateBasket(data.basket);
                } else {
                    if (data.toBeDeletedUUIDs && data.toBeDeletedUUIDs.length > 0) {
                        for (var i = 0; i < data.toBeDeletedUUIDs.length; i++) {
                            $(".uuid-" + data.toBeDeletedUUIDs[i]).remove();
                        }
                    }
                    $(".uuid-" + uuid).remove();

                    if ($cardContainerStringing.length) {
                        $cardContainerStringing.each((_i, el) => {
                            const $thisEl = $(el);

                            if ($thisEl.attr("id") === uuid) {
                                $thisEl.remove();
                            }
                        });

                        if ($(".card-container-stringing").length === 0) {
                            $(".service-cordage").remove();
                        }
                    }

                    if (!data.basket.hasBonusProduct) {
                        $(".bonus-product").remove();
                    }

                    if (data.basket && data.basket.numItems == 0) {
                        $(".disclaimer-error-message").addClass("d-none").removeClass("d-flex");
                        $("button.add-to-cart, button.btn-stringing").removeAttr("disabled");
                    }

                    $(".coupons-and-promos").empty().append(data.basket.totals.discountsHtml);
                    updateCartTotals(data.basket);
                    updateApproachingDiscounts(data.basket.approachingDiscountsTemplate);
                    $body.trigger("setShippingMethodSelection", data.basket);
                    validateBasket(data.basket);

                    if (data.expliciteProductsTemplate && data.expliciteProductsTemplate.length) {
                        $(".js-explicite-products").empty().append(data.expliciteProductsTemplate);
                    } else {
                        $(".js-explicite-products").empty();
                    }
                }

                $body.trigger("cart:update");
                $body.trigger("cart:basketTotalUpdate", { almaWidgetCartTotal: data.almaWidgetCartTotal });

                if ($minicartPopover.length && $minicartPopover.hasClass("show")) {
                    $minicartPopover.find(".js-minicart-close").trigger("click");
                }

                $.spinner().stop();
            },
            error: function (err) {
                if (err.responseJSON.redirectUrl) {
                    window.location.href = err.responseJSON.redirectUrl;
                } else {
                    createErrorNotification(err.responseJSON.errorMessage);
                    $.spinner().stop();
                }
            }
        });
    });

    $body.on("change", ".quantity-form > .quantity", function () {
        var $this = $(this);
        var preSelectQty = $this.data("pre-select-qty");
        var quantity = $this.val();
        var productID = $this.data("pid");
        var url = $this.data("action");
        var uuid = $this.data("uuid");
        var urlParams = {
            pid: productID,
            quantity: quantity,
            uuid: uuid
        };
        // var $couponErrorMessage = $(".coupon-error-message");
        // var $couponErrorMessageWrapper = $(".coupon-error-message-wrapper");
        // var classErrorMessage = "c-error-message d-flex";
        // var $promoCodeForm = $(".promo-code-form .form-control");
        // var isInvalid = "is-invalid";

        // $promoCodeForm.removeClass(isInvalid);
        // $couponErrorMessage.empty();
        // $couponErrorMessageWrapper.removeClass(classErrorMessage);

        $cardContainerStringing = $(".card-container-stringing");
        url = appendToUrl(url, urlParams);

        $this.closest(".card").spinner().start();

        $.ajax({
            url: url,
            type: "get",
            context: this,
            dataType: "json",
            success: function (data) {
                $(".quantity[data-uuid=\"" + uuid + "\"]").val(quantity);
                $(".coupons-and-promos").empty().append(data.totals.discountsHtml);
                updateCartTotals(data);
                updateApproachingDiscounts(data.approachingDiscountsTemplate);
                $(".js-update-products-cards").html(data.cartProductsTemplate);
                updateAvailability(data, uuid);
                validateBasket(data);
                $this.data("pre-select-qty", quantity);

                $body.trigger("cart:update");
                $body.trigger("cart:basketTotalUpdate", { almaWidgetCartTotal: data.almaWidgetCartTotal });
                $.spinner().stop();

                if ($this.parents(".product-info").hasClass("bonus-product-line-item") && $(".cart-page").length) {
                    location.reload();
                }

                let cartQuantitySelect = document.querySelector(".quantity-form").querySelector(".quantity");
                outFocusMenu.init(cartQuantitySelect);
                lazyLoading.refreshLazyLoadingFeature();

                if ($cardContainerStringing.length) {
                    productStringing();
                }
            },
            error: function (err) {
                if (err.responseJSON.redirectUrl) {
                    window.location.href = err.responseJSON.redirectUrl;
                } else {
                    createErrorNotification(err.responseJSON.errorMessage);
                    $(this).val(parseInt(preSelectQty, 10));
                    $.spinner().stop();
                }
            }
        });
    });

    $body.on("cart:afterAttributeSelect", function (e, response) {
        if (response) {
            response.container.data("pid", response.data.product.id);
        }
    });

    $(".shippingMethods").change(function () {
        var $this = $(this);
        var url = $this.attr("data-actionUrl");
        var urlParams = {
            methodID: $this.find(":selected").attr("data-shipping-id")
        };
        // url = appendToUrl(url, urlParams);

        $(".totals").spinner().start();
        $.ajax({
            url: url,
            type: "post",
            dataType: "json",
            data: urlParams,
            success: function (data) {
                if (data.error) {
                    window.location.href = data.redirectUrl;
                } else {
                    $(".coupons-and-promos").empty().append(data.totals.discountsHtml);
                    updateCartTotals(data);
                    updateApproachingDiscounts(data.approachingDiscountsTemplate);
                    validateBasket(data);
                }
                $.spinner().stop();
            },
            error: function (err) {
                if (err.redirectUrl) {
                    window.location.href = err.redirectUrl;
                } else {
                    createErrorNotification(err.responseJSON.errorMessage);
                    $.spinner().stop();
                }
            }
        });
    });

    $(".promo-code-form").submit(function (e) {
        e.preventDefault();

        var $form = $(this);
        var $couponErrorMessage = $form.find(".coupon-error-message");
        var $couponErrorMessageWrapper = $form.find(".coupon-error-message-wrapper");
        var $couponMissingError = $form.find(".coupon-missing-error");
        var $promoCodeInput = $form.find(".coupon-code-field");
        var classErrorMessage = "c-error-message d-flex";
        var isValid = "is-valid";
        var isInvalid = "is-invalid";
        $cardContainerStringing = $(".card-container-stringing");

        $.spinner().start();

        // check if we can remove the notifications or not
        var allowCleanNotifications = true;
        var couponActionBtn = $couponErrorMessageWrapper.find("button.remove-coupon");

        if (couponActionBtn.length > 0) {
            // if the notification panel contain no coupon UUID, we can remove them since they do not allow any action
            var storedUUID = couponActionBtn[0].dataset["uuid"];

            allowCleanNotifications = storedUUID == "null" || storedUUID == "" || typeof storedUUID == "undefined";
        }

        $couponMissingError.removeClass(classErrorMessage);

        if (allowCleanNotifications) {
            $couponErrorMessage.empty();
            $couponErrorMessageWrapper.removeClass(classErrorMessage);
        }

        $promoCodeInput.val(removeHTMLTags($promoCodeInput.val()));

        if (!$promoCodeInput.val()) {
            $promoCodeInput.removeClass(isValid).addClass(isInvalid);
            $promoCodeInput.attr("aria-describedby", "missingCouponCode");
            $couponMissingError.addClass(classErrorMessage);
            $.spinner().stop();
            return false;
        }

        $promoCodeInput.removeClass(isInvalid);

        $.ajax({
            url: $form.attr("action"),
            type: "GET",
            dataType: "json",
            data: $form.serialize(),
            success: function (data) {
                var removeCouponBtn = $couponErrorMessageWrapper.find(".remove-coupon");
                //Adding CouponCode into remove button
                removeCouponBtn.attr("data-code", data.couponCode);
                //Adding couponId into remove button (black cross)
                removeCouponBtn.attr("data-uuid", data.couponId);
                //Adding couponId into modal pop up (#removeCouponModal) when the id is correct
                $(".delete-coupon-confirmation-btn").attr("data-uuid", data.couponId);
                if (data.error) {
                    // Displays the correct coupon error message in the cart and checkout page
                    updateCouponMessage();
                    // If the deleteErrorMessage is true means we can delete the messages below coupon field
                    if (!data.deleteErrorMessage) {
                        $promoCodeInput.removeClass(isValid).addClass(isInvalid).attr("aria-describedby", "invalidCouponCode");
                        $couponErrorMessage.empty().append(data.errorMessage);
                        $couponErrorMessageWrapper.addClass(classErrorMessage);
                    }
                } else {
                    $(".coupons-and-promos").empty().append(data.totals.discountsHtml);
                    updateCartTotals(data);
                    updateApproachingDiscounts(data.approachingDiscountsTemplate);
                    $(".js-update-products-cards").html(data.cartProductsTemplate);
                    validateBasket(data);
                    refreshEinsteinRecommendations();
                }

                if ($cardContainerStringing.length) {
                    productStringing();
                }

                $promoCodeInput.val("");
                $.spinner().stop();
                lazyLoading.refreshLazyLoadingFeature();
            },
            error: function (err) {
                if (err.responseJSON.redirectUrl) {
                    window.location.href = err.responseJSON.redirectUrl;
                } else {
                    createErrorNotification(err.errorMessage);
                    $.spinner().stop();
                }
            }
        });
    });

    $body.on("click", ".remove-coupon", function (e) {
        e.preventDefault();

        var $this = $(this);
        var couponCode = $this.data("code");
        var $deleteConfirmBtn = $(".delete-coupon-confirmation-btn");
        var $productToRemoveSpan = $(".coupon-to-remove");
        // Get the value from input which is the data-target value for displaying the remove coupon modal
        var dataTarget = $(".input-removeCouponModal").val();
        // Set data-target attribute into the field button in case it isn't
        $(".btn-removeCoupon-modal").attr("data-target", dataTarget);
        // Get the new UUID to delete the coupon error message
        var newUuid = $(e.currentTarget)[0].dataset.uuid;

        $deleteConfirmBtn.attr("data-uuid", newUuid);
        $deleteConfirmBtn.attr("data-code", couponCode);

        $productToRemoveSpan.empty().append(couponCode);

        // If newUuid doesn't exist it means the coupon entered doesn't exist, we delete all messages to avoid calling the modal because if not endpoint Cart-RemoveCoupon will be called with no coupon to delete and it will crash.
        if (!newUuid || typeof newUuid =="undefined") {
            var isInvalid = "is-invalid";
            var $promoCodeForm = $(".promo-code-form .form-control");
            var $couponErrorMessage = $(".coupon-error-message");
            var $couponErrorMessageWrapper = $(".coupon-error-message-wrapper");
            var classErrorMessage = "c-error-message d-flex";
            // Set data-target attribute into the field button to null so that the modal is not displayed
            $(".btn-removeCoupon-modal").attr("data-target", "");
            // Remove all errors from the coupon field so that the new field is clear
            $promoCodeForm.removeClass(isInvalid);
            $couponErrorMessage.empty();
            $couponErrorMessageWrapper.removeClass(classErrorMessage);
        } else {
            // It means the coupon is valid and exists so we display the remove coupon modal
            $(".btn-removeCoupon-modal").attr("data-target", dataTarget);
        }
    });

    $body.on("click", ".delete-coupon-confirmation-btn", function (e) {
        e.preventDefault();

        var $this = $(this);
        var url = $this.data("action");
        var uuid = $(e.currentTarget)[0].dataset.uuid;
        var couponCode = $this.data("code");
        var urlParams = {
            code: couponCode,
            uuid: uuid
        };
        $cardContainerStringing = $(".card-container-stringing");
        url = appendToUrl(url, urlParams);

        $("body > .modal-backdrop").remove();

        $.spinner().start();
        // If the id doesn't exist even when entering a correct coupon, when validating the modal pop up (#removeCouponModal) we make sure to delete all error messages
        if (!uuid || uuid == "undefined") {
            $("#removeCouponModal").hide();
            $(".coupons-and-promos").empty();
            $.spinner().stop();
        // if not it means everything is correct and we have the id
        } else {
            $.ajax({
                url: url,
                type: "get",
                dataType: "json",
                success: function (data) {
                    $(".coupon-uuid-" + uuid).remove();
                    updateCartTotals(data);
                    updateApproachingDiscounts(data.approachingDiscountsTemplate);
                    $(".js-update-products-cards").html(data.cartProductsTemplate);

                    // update discounts area with newly calculated promotions effects
                    var discountsHtml = data.totals.discountsHtml;

                    if (discountsHtml) {
                        $(".coupons-and-promos").html(discountsHtml);
                    }

                    validateBasket(data);

                    if ($cardContainerStringing.length) {
                        productStringing();
                    }
                    var $promoCodeForm = $(".promo-code-form .form-control");
                    var $couponErrorMessage = $(".coupon-error-message");
                    var $couponErrorMessageWrapper = $(".coupon-error-message-wrapper");
                    var classErrorMessage = "c-error-message d-flex";
                    var isInvalid = "is-invalid";
                    $couponErrorMessage.empty();
                    $couponErrorMessageWrapper.removeClass(classErrorMessage);
                    $promoCodeForm.removeClass(isInvalid);

                    $.spinner().stop();
                    lazyLoading.refreshLazyLoadingFeature();
                    refreshEinsteinRecommendations();
                },
                error: function (err) {
                    if (err.responseJSON.redirectUrl) {
                        window.location.href = err.responseJSON.redirectUrl;
                    } else {
                        createErrorNotification(err.responseJSON.errorMessage);
                        $.spinner().stop();
                    }
                }
            });
        }
    });

    $body.on("click", ".cart-page .bonus-product-button", function () {
        $.spinner().start();

        var $this = $(this);

        $this.addClass("launched-modal");
        $.ajax({
            url: $this.data("url"),
            method: "GET",
            dataType: "json",
            success: function (data) {
                base.methods.editBonusProducts(data);
                $.spinner().stop();
            },
            error: function () {
                $.spinner().stop();
            }
        });
    });

    $body.on("hidden.bs.modal", "#chooseBonusProductModal", function () {
        $("#chooseBonusProductModal").remove();
        $(".modal-backdrop").remove();
        $body.removeClass("modal-open");

        if ($(".cart-page").length) {
            $(".launched-modal .btn-outline-primary").trigger("focus");
            $(".launched-modal").removeClass("launched-modal");
        } else {
            $(".product-detail .add-to-cart").focus();
        }
    });

    $body.on("click", ".cart-page .product-edit .edit, .cart-page .bundle-edit .edit", function (e) {
        e.preventDefault();

        var $this = $(this);
        var editProductUrl = $this.attr("href");
        var updateSection = ".js-update-section";

        $.spinner().start();
        $.ajax({
            url: editProductUrl,
            method: "GET",
            dataType: "json",
            success: function (data) {
                var $productInfo = $this.closest(".product-info");

                $productInfo.find(".item-attributes").addClass("d-none");
                $productInfo.find(updateSection).html(data.renderedTemplate);
                $productInfo.find(updateSection).removeClass("d-none");
                $productInfo.find(".remove-product").hide();
                $productInfo.find(".js-update-cart-close").removeClass("d-none");
                $.spinner().stop();
            },
            error: function () {
                $.spinner().stop();
            }
        });
    });

    $body.on("shown.bs.modal", "#editProductModal", function () {
        $("#editProductModal").siblings().attr("aria-hidden", "true");
        $("#editProductModal .close").focus();
    });

    $body.on("hidden.bs.modal", "#editProductModal", function () {
        $("#editProductModal").siblings().attr("aria-hidden", "false");
    });

    $body.on("keydown", "#editProductModal", function (e) {
        var focusParams = {
            event: e,
            containerSelector: "#editProductModal",
            firstElementSelector: ".close",
            lastElementSelector: ".update-cart-product-global",
            nextToLastElementSelector: ".modal-footer .quantity-select"
        };
        focusHelper.setTabNextFocus(focusParams);
    });

    $body.on("product:updateAddToCart", function (e, response) {
        // update global add to cart (single products, bundles)
        var dialog = $(response.$productContainer)
            .closest(".quick-view-dialog");
        var $globalAvailability = $(".global-availability", dialog);

        $(".update-cart-product-global", dialog).attr("disabled",
            !$globalAvailability.data("ready-to-order")
            || !$globalAvailability.data("available")
        );
    });

    $body.on("product:updateAvailability", function (e, response) {
        // bundle individual products
        $(".product-availability", response.$productContainer)
            .data("ready-to-order", response.product.readyToOrder)
            .data("available", response.product.available)
            .find(".availability-msg")
            .empty()
            .html(response.message);

        if (response.isCart) {
            response.$productContainer.find("button.add-to-cart-from-cart").empty()
                .html(!response.product.available ? response.resources.outOfStock : (response.product.readyToOrder ? response.resources.addtocartText : response.resources.info_selectforstock));
            var buttonState = (!response.product.readyToOrder || !response.product.available);
            response.$productContainer.find("button.add-to-cart-from-cart", response.$productContainer).attr("disabled", buttonState).removeClass("d-none");
        }

        var dialog = $(response.$productContainer)
            .closest(".quick-view-dialog");
        var $globalAvailabilityDialog = $(".global-availability", dialog);
        var $productAvailability = $(".product-availability", dialog);

        if ($productAvailability.length) {
            // bundle all products
            var allAvailable = $productAvailability.toArray()
                .every(function (item) { return $(item).data("available"); });
            var allReady = $productAvailability.toArray()
                .every(function (item) { return $(item).data("ready-to-order"); });

            $globalAvailabilityDialog
                .data("ready-to-order", allReady)
                .data("available", allAvailable);

            $(".global-availability .availability-msg", dialog).empty()
                .html(allReady ? response.message : response.resources.info_selectforstock);
        } else {
            // single product
            $globalAvailabilityDialog
                .data("ready-to-order", response.product.readyToOrder)
                .data("available", response.product.available)
                .find(".availability-msg")
                .empty()
                .html(response.message);
        }
    });

    $body.on("product:afterAttributeSelect", function (e, response) {
        var $responseContainer = $(response.container);
        var $updateCartProductGlobal = $(".update-cart-product-global");

        if ($(".product-quickview .bundle-items").length) {
            $responseContainer.find(response.container).data("pid", response.data.product.id);
            $responseContainer.find(response.container).find(".product-id").text(response.data.product.id);
        } else {
            if (response.data.product) {
                $responseContainer.data("pid", response.data.product.id);

                if (response.data.product.available && response.data.product.readyToOrder) {
                    $updateCartProductGlobal.removeAttr("disabled");
                } else {
                    $updateCartProductGlobal.attr("disabled", true);
                }
            }
        }
        // Get quantity selector
        let qtySelector = $(".quantity-select");
        // If it has options to select and no option has been selected set it to the first value
        if ($(".quantity-select option:selected").length == 0 && qtySelector.length > 0) {
            qtySelector.val($(".quantity-select option:nth-child(1)").val());
        }
    });

    $body.on("change", ".quantity-select", function () {
        var selectedQuantity = $(this).val();
        $(".modal.show .update-cart-url").data("selected-quantity", selectedQuantity);
    });

    $body.on("change", ".options-select", function () {
        var selectedOptionValueId = $(this).children("option:selected").data("value-id");
        $(".modal.show .update-cart-url").data("selected-option", selectedOptionValueId);
    });

    $body.on("click", ".update-cart-product-global", function (e) {
        e.preventDefault();

        var $this = $(this);
        var $updateCartUrl = $this.closest(".cart-and-ipay").find(".update-cart-url");
        var updateProductUrl = $updateCartUrl.val();
        var selectedQuantity = $updateCartUrl.data("selected-quantity");
        var selectedOptionValueId = $updateCartUrl.data("selected-option");
        var uuid = $updateCartUrl.data("uuid");
        var form = {
            uuid: uuid,
            pid: $this.closest(".product-quickview").data("pid"),
            quantity: selectedQuantity,
            selectedOptionValueId: selectedOptionValueId
        };

        const $babolatCupBlock = $this.closest(".js-babolatcup-lineitem");

        if ($babolatCupBlock.length) {
            form.isBabolatCup = true;
            form.participantFirstName = $babolatCupBlock.find("[name='participantFirstName']").val();
            form.participantLastName = $babolatCupBlock.find("[name='participantLastName']").val();
            form.dateOfBirth = $babolatCupBlock.find("[name='dateOfBirth']").val();
            form.licenceNumber = $babolatCupBlock.find("[name='licenceNumber']").val();
            form.club = $babolatCupBlock.find("[name='club']").val();
            form.age = $babolatCupBlock.find("[name='age'] option:selected").html().trim();
        }

        $cardContainerStringing = $(".card-container-stringing");
        $this.parents(".card").spinner().start();

        if (updateProductUrl) {
            $.ajax({
                url: updateProductUrl,
                type: "post",
                context: this,
                data: form,
                dataType: "json",
                success: function (data) {
                    var $productInfo = $this.closest(".product-info");

                    $productInfo.find(".item-attributes").removeClass("d-none");
                    $productInfo.find(".js-update-section").addClass("d-none");
                    $productInfo.find(".remove-product").show();
                    $productInfo.find(".js-update-cart-close").addClass("d-none");
                    $(".coupons-and-promos").empty().append(data.cartModel.totals.discountsHtml);
                    updateCartTotals(data.cartModel);
                    updateApproachingDiscounts(data.cartModel.approachingDiscountsTemplate);
                    $(".js-update-products-cards").html(data.cartModel.cartProductsTemplate);
                    updateAvailability(data.cartModel, uuid);
                    updateProductDetails(data, uuid);

                    if ($cardContainerStringing.length) {
                        productStringing();
                    }

                    lazyLoading.refreshLazyLoadingFeature();

                    if (data.uuidToBeDeleted) {
                        $(".uuid-" + data.uuidToBeDeleted).remove();
                    }

                    validateBasket(data.cartModel);

                    $body.trigger("cart:update");
                    $body.trigger("cart:basketTotalUpdate", { almaWidgetCartTotal: data.almaWidgetCartTotal });

                    $.spinner().stop();
                },
                error: function (err) {
                    if (err.responseJSON.redirectUrl) {
                        window.location.href = err.responseJSON.redirectUrl;
                    } else {
                        createErrorNotification(err.responseJSON.errorMessage);
                        $.spinner().stop();
                    }
                }
            });
        }
    });

    $body.on("click", ".js-update-cart-close", function (e) {
        e.preventDefault();

        let $this = $(this);
        let $productInfo = $this.closest(".product-info");

        $productInfo.find(".item-attributes").removeClass("d-none");
        $productInfo.find(".js-update-section").addClass("d-none");
        $productInfo.find(".remove-product").show();
        $this.addClass("d-none");
    });

    $body.on("click", ".promo-code-label", function () {
        const $this = $(this);
        $this.closest(".c-accordion").toggleClass("active");
    });

    $("[data-toggle='tooltip']").each(function () {
        let $this = $(this);
        let placement = $this.data("placement");

        $this.tooltip({
            container: $this.parent(),
            placement: placement ? placement : (window.mqRespond.status.xsOnly ? "bottom" : "right")
        });
    });

    $body.on("cart:size-select", function (e, response) {
        if (response && response.container) {
            const $container = $(response.container);
            const $sizeSelector = $container.find(".m-product-detail__size-select");
            var hasOneSelectableAttribute = false;

            if ($sizeSelector.length) {
                hasOneSelectableAttribute = $($sizeSelector[0].options).filter((i, option) =>option.getAttribute("disabled") !== "disabled" && option.classList.contains("selectable")).length === 1;
            }

            // If size selector has more than 1 option show disable button "CHOOSE SIZE", if not show "ADD TO CART"
            if ($sizeSelector.length && hasOneSelectableAttribute) {
                $sizeSelector.find("option:not([disabled]):first").attr("selected", "selected");
                $container.addClass("size-selected");
                $sizeSelector.trigger("change");
            }
        }
    });

    if (isCart) {base.availability();}

    productSamplePushTileEvents();

    base.selectAttribute();
    base.colorAttribute();
    base.removeBonusProduct();
    base.selectBonusProduct();
    base.enableBonusProductSelection();
    base.showMoreBonusProducts();
    base.addBonusProductsToCart();
    base.focusChooseBonusProductModal();
    base.trapChooseBonusProductModalFocus();
    base.onClosingChooseBonusProductModal();
};
